import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DppEnrollmentEffects } from './effects/dpp-enrollment.effects';
import { dppEnrollmentReducer } from './reducers/dpp-enrollment.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature('dppEnrollment', dppEnrollmentReducer),
        EffectsModule.forFeature([DppEnrollmentEffects]),
    ],
})
export class DppEnrollmentStoreModule {}
